(ns frontend.view.settings2.counterparty-diligence.model)

(def root-path [::state])

(def config-key :config)

(def config-full-path (conj root-path config-key))

(def saving-key :saving?)

(def saving-full-path (conj root-path saving-key))

(def preview-notification-id-key :preview-notification-id)

(def preview-notification-id-full-path
  (conj root-path preview-notification-id-key))

(def preview-variant-template-id-key :preview-variant-template-id)

(def invalid-emails-key :invalid-emails)
